import { Typography } from '@mui/material';

interface LoadingWrapperProps {
  loading?: boolean;
  children: JSX.Element;
}

const LoadingWrapper = ({ loading, children }: LoadingWrapperProps) => {
  if (loading) {
    return <Typography>loading</Typography>;
  }
  return children;
};

export default LoadingWrapper;
